import React from 'react';

import { DescriptionList, DescriptionItem } from '@gogame/components';

const FileBasedAudienceGeneral = ({ data }) => {
  return (
    <DescriptionList disableGutters data={data}>
      <DescriptionItem label={'Type'} field={'type.name'} />
      <DescriptionItem
        label={'Applications'}
        field={'applications'}
        valueParser={'commaList'}
      />
      <DescriptionItem
        label={'Networks'}
        field={'networks'}
        valueParser={'commaList'}
      />
      <DescriptionItem
        label={'Platforms'}
        field={'platforms'}
        valueParser={'commaList'}
      />
    </DescriptionList>
  );
};

export default FileBasedAudienceGeneral;
